
<video loop muted autoplay oncanplay="this.play()" onloadedmetadata="this.muted = true">
  <source src="assets/video.mp4" type="video/mp4" />
</video>

<div class="position-fixed bottom-0 left-0 m-5 p-5 text-white d-md-none">
  <h6>
    Simply write.<br />
    <b class="gradient-text">Gitten</b> will do the rest.
  </h6>
  <h1 class="huge mt-2 text-left" style="text-align: left">
    <b class="gradient-text">Light-up</b> your repo<br />with
    <b class="gradient-text">Gitten</b>
  </h1>
  <h6>AI&emsp;\&emsp;REPO&emsp;\&emsp;WORKFLOWS</h6>
</div>

<nb-card class="login text-white">
  <nb-card-body>
    <div class="pt-3 mx-3 text-white">
      <h6>
        Simply write.<br />
        <b class="gradient-text">Gitten</b> will do the rest.
      </h6>
      <h1 class="huge mt-2 text-left" style="text-align: left">
        <b class="gradient-text">Light-up</b> your repo with <b class="gradient-text">Gitten</b>
      </h1>
      <h6>AI&emsp;\&emsp;REPO&emsp;\&emsp;WORKFLOWS</h6>
    </div>
    <div class="content text-white p-3">
      <h2 class="mb-2 text-white">Welcome in <b class="gradient-text">Gitten</b></h2>
      <p class=" text-white">
        Gitten is a great management system that uses GitHub as a backend.<br />
        <br />

        <br />
        To get started, <b>login with your GitHub</b> account. Then you'll be
        asked to authorize <b>Insighter</b> as GitHub OAuth app.<br />
      </p>
      <hr>
      <div
        class="p-6 color-bg-emphasis rounded-2 text-center p-2 d-md-none"
        style="background: #fff1"
      >
        <div class="d-flex justify-content-center mx-auto my-2 w-100">
          <div class="MarketplaceFeature col-3 flex-auto px-2 anim-fade-in  text-white">
            <a
              class="no-underline MarketplaceFeature-link"
              data-hydro-click='{"event_type":"marketplace_listing_click","payload":{"marketplace_listing_id":19478,"location":"featured_apps_section","source_url":"https://github.com/marketplace/gittenapp/edit/description","destination_url":"https://github.com/marketplace/gittenapp","originating_url":"https://github.com/marketplace/gittenapp/edit/description","user_id":64726971}}'
              data-hydro-click-hmac="b2222c045653b212f4db1906b2550dd34c4098dafee8c56f4a1de39b61c1cc5a"
            >
              <div
                class="p-4 text-center rounded-2 color-shadow-medium mb-4 js-hero-listing-container color-bg-default"
                style="
                  background-size: cover;
                  background-position: center top;
                "
              >
                <div
                  class="CircleBadge CircleBadge--medium CircleBadge--feature mx-auto js-hero-listing-bgcolor"
                  style="background-color: #ffffff"
                >
                  <img
                    class="CircleBadge-icon"
                    alt=""
                    src="https://avatars.githubusercontent.com/ml/19478?cache=1730366958&amp;s=106&amp;v=4"
                  />
                </div>
                <h3 class="h2 no-wrap js-hero-listing-name color-fg-default">
                  GittenApp
                </h3>
              </div>
            </a>
            <p
              class="MarketplaceFeature-text color-text-white text-center px-3 lh-condensed js-hero-listing-description"
            >
              An online accelerated content editing for GitHub repos
            </p>
          </div>
        </div>
      </div>
      <hr class="d-md-none"/>
      <a class="btn rounded-pill active w-100" (click)="loginMicrosoft()" *ngIf="!logged">
        <i class="fab fa-github"></i>
        Login with GitHub
      </a>
      <a class="btn rounded-pill active w-100" [routerLink]="'pages'" *ngIf="logged">
        <i class="fab fa-github"></i>
        Let's go
      </a>
    </div>
  </nb-card-body>
</nb-card>
